module.exports = __webpack_public_path__ + "img/main.e5ff7d8c.png";